import { useForm } from "react-hook-form";

const useFilterForm = ({ value, onChange }) => {
	const form = useForm({
		defaultValues: value
	});

	const { watch } = form;

	watch(values => {
		onChange(values);
	});

	return form;
};

export default useFilterForm;
